import React from 'react';

const BillingPage = ({
  active,
  invoices,
  quotations,
  onAddInvoice,
  onAddQuotation,
  onDeleteInvoice,
  onDeleteQuotation,
  onInvoiceStatusChange,
  onQuotationStatusChange,
}) => (
  <section className={`section ${active ? 'active' : ''}`} data-testid="billing-section">
    <div className="section-header">
      <div>
        <div className="section-title">Sales & Finance</div>
        <div className="section-subtitle">Kelola penawaran, tagihan, dan riwayat pembayaran klien.</div>
      </div>
      <div style={{ display: 'flex', gap: '8px' }}>
        <button className="btn btn-ghost" onClick={onAddQuotation} data-testid="open-add-quotation-btn">+ New Quote</button>
        <button className="btn btn-gold" onClick={onAddInvoice} data-testid="open-add-invoice-btn">+ New Invoice</button>
      </div>
    </div>
    <div className="billing-summary">
      <div className="billing-card" style={{ borderColor: 'rgba(39,174,96,0.2)' }}>
        <div className="billing-card-label">Total Terkumpul</div>
        <div className="billing-card-amount" style={{ color: '#2ECC71' }}>Rp 39,9M</div>
        <div className="billing-card-sub">Dari pembayaran masuk</div>
      </div>
      <div className="billing-card" style={{ borderColor: 'rgba(212,175,55,0.2)' }}>
        <div className="billing-card-label">Menunggu Pembayaran</div>
        <div className="billing-card-amount" style={{ color: 'var(--gold)' }}>Rp 9,57M</div>
        <div className="billing-card-sub">Dari invoice aktif</div>
      </div>
      <div className="billing-card" style={{ borderColor: 'rgba(192,57,43,0.2)' }}>
        <div className="billing-card-label">Jatuh Tempo</div>
        <div className="billing-card-amount" style={{ color: '#E74C3C' }}>Rp 3,24M</div>
        <div className="billing-card-sub">Invoice melewati batas</div>
      </div>
      <div className="billing-card">
        <div className="billing-card-label">Penawaran Aktif (Quotes)</div>
        <div className="billing-card-amount" style={{ color: 'var(--text-primary)' }}>
          {quotations.filter(q => q.status === 'sent').length} Terkirim
        </div>
        <div className="billing-card-sub">Menunggu persetujuan</div>
      </div>
    </div>

    <div className="glass-panel" style={{ marginBottom: '24px' }}>
      <div className="glass-panel-header">
        <div className="glass-panel-title">ACTIVE INVOICES</div>
      </div>
      <div className="panel-body">
        <table className="crm-table">
          <thead>
            <tr>
              <th>Invoice ID</th><th>Client Name</th><th>Amount</th>
              <th>Issue Date</th><th>Due Date</th><th>Status</th>
              <th style={{ textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {invoices.map(inv => (
              <tr key={inv.id} data-testid={`invoice-row-${inv.id}`}>
                <td><span style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--gold)' }}>{inv.id}</span></td>
                <td style={{ fontWeight: '500' }}>{inv.client}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '13px', fontWeight: '600' }}>{inv.amount}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--text-muted)' }}>{inv.issued}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--text-secondary)' }}>{inv.due}</td>
                <td>
                  <select
                    className={`badge badge-${inv.status}`}
                    value={inv.status}
                    onChange={(e) => onInvoiceStatusChange(inv.id, e.target.value)}
                    style={{ cursor: 'pointer', outline: 'none', appearance: 'auto', paddingRight: '16px', border: 'none' }}
                    data-testid={`invoice-status-${inv.id}`}
                  >
                    <option value="paid" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>PAID</option>
                    <option value="pending" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>PENDING</option>
                    <option value="overdue" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>OVERDUE</option>
                  </select>
                </td>
                <td style={{ textAlign: 'right' }}>
                  <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <button
                      className="btn-icon-danger"
                      onClick={() => onDeleteInvoice(inv.id)}
                      title="Hapus"
                      data-testid={`delete-invoice-btn-${inv.id}`}
                    >🗑</button>
                  </div>
                </td>
              </tr>
            ))}
            {invoices.length === 0 && (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)' }}>Belum ada invoice.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>

    <div className="glass-panel">
      <div className="glass-panel-header">
        <div className="glass-panel-title">RECENT QUOTATIONS</div>
      </div>
      <div className="panel-body">
        <table className="crm-table">
          <thead>
            <tr>
              <th>Quote ID</th><th>Client Name</th><th>Amount</th>
              <th>Date Sent</th><th>Valid Until</th><th>Status</th>
              <th style={{ textAlign: 'right' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {quotations.map(quo => (
              <tr key={quo.id} data-testid={`quotation-row-${quo.id}`}>
                <td><span style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--blue)' }}>{quo.id}</span></td>
                <td style={{ fontWeight: '500' }}>{quo.client}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '13px', fontWeight: '600' }}>{quo.amount}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--text-muted)' }}>{quo.date}</td>
                <td style={{ fontFamily: "'JetBrains Mono'", fontSize: '12px', color: 'var(--text-secondary)' }}>{quo.validUntil}</td>
                <td>
                  <select
                    className={`badge badge-${quo.status === 'draft' ? 'warm' : quo.status === 'sent' ? 'cold' : quo.status === 'accepted' ? 'paid' : 'hot'}`}
                    value={quo.status}
                    onChange={(e) => onQuotationStatusChange(quo.id, e.target.value)}
                    style={{ cursor: 'pointer', outline: 'none', appearance: 'auto', paddingRight: '16px', border: 'none' }}
                    data-testid={`quotation-status-${quo.id}`}
                  >
                    <option value="draft" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>DRAFT</option>
                    <option value="sent" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>SENT</option>
                    <option value="accepted" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>ACCEPTED</option>
                    <option value="rejected" style={{ background: 'var(--black-2)', color: 'var(--text-primary)' }}>REJECTED</option>
                  </select>
                </td>
                <td style={{ textAlign: 'right' }}>
                  <div style={{ display: 'flex', gap: '6px', justifyContent: 'flex-end', alignItems: 'center' }}>
                    <button
                      className="btn-icon-danger"
                      onClick={() => onDeleteQuotation(quo.id)}
                      title="Hapus"
                      data-testid={`delete-quotation-btn-${quo.id}`}
                    >🗑</button>
                  </div>
                </td>
              </tr>
            ))}
            {quotations.length === 0 && (
              <tr><td colSpan="7" style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)' }}>Belum ada penawaran.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default BillingPage;
